var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('peek-form',{attrs:{"footer":false,"title":_vm.$t('favourite_addresses')}},[_c('q-page',{attrs:{"padding":""}},[_c('address-list',{attrs:{"addresses":_vm.savedLocations}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }